import {hoverIntent} from "./hover-intent/hover-intent";

const isVisible = (el) => !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);

export default function InitHeader() {

  const ticker = document.getElementById("ticker");
  if (ticker && "ResizeObserver" in window) {
    new ResizeObserver(() => {
      if (ticker.offsetHeight > 0) {
        document.documentElement.style.setProperty("--ticker-height", `${ticker.offsetHeight}px`);
      }
    }).observe(ticker);
  }

  /**
   *  Open Mobile Menu if clicked on the burger icon
   */
  document.querySelector(".menu__button")?.addEventListener("click", (e) => {
    const root = document.documentElement;
    root.classList.toggle("header-open");
    e.currentTarget.classList.toggle("menu__button--open");
    document.querySelector(".hidden-desktop .header__menu")?.classList.toggle("header__menu--open");
    root.classList.toggle("lock-scroll");
    if (root.classList.contains("header-open")) {
      document.querySelectorAll(".mega-menu").forEach(el => el.classList.remove("mega-menu--open"));
      toggleSearchContainer(true);
    } else {
      handleNavigationClosure();
    }
  });

  /**
   * Activate the background overlay if hovering over mobile menu level 1
   * Hide header search if any mega menu / submenu is activated, and show it back after closing
   */
  const menuItems = document.querySelectorAll(".item--level-1.item--has-megamenu-children, .item--level-1.item--has-submenu-children");

  for (const menuItem of menuItems) {
    hoverIntent(
      menuItem,
      () => {
        menuItem.classList.add("hover-intent");
        document.body.classList.add("body", "body--menu-open");
        document.documentElement.classList.add("lock-scroll");

        const searchContainer = document.querySelector(".header__search-container");
        if (searchContainer?.classList.contains("header__search-container--active")) {
          searchContainer.style.display = "none";
        }
      },
      () => {
        menuItem.classList.remove("hover-intent");
        document.body.classList.remove("body", "body--menu-open");
        document.documentElement.classList.remove("lock-scroll");

        const searchContainer = document.querySelector(".header__search-container");
        if (searchContainer?.classList.contains("header__search-container--active")) {
          searchContainer.style.display = "";
        }
      },
      {
        timeout: 200
      },
    );
  }

  /**
   * Close the mobile menu on window resize, if the desktop view is already visible
   */
  window.addEventListener("resize", function () {
    const menuButton = document.querySelector(".menu__button");
    if (menuButton && !isVisible(menuButton)) {
      handleNavigationClosure();
    }
  });

  /**
   * Open the next Mobile Menu Level, when there's a click on the parent.
   */
  document.querySelectorAll(".item__link__wrapper").forEach(el => {
    el.addEventListener("click", function (e) {
      if (e.target.tagName === "A") return;
      const item = this.closest(".item");
      if (item?.classList.contains("item--has-children")) {
        item.classList.toggle("item--is--open");
      }
    });
  });

  /**
   * Add the body node the scroll state to force header changes (eg. update of the logo size)
   */
  window.addEventListener("scroll", function () {
    const body = document.body;

    if (window.scrollY !== 0 && window.scrollY > 85) {
      if (!body.classList.contains("scroll")) {
        // the scrollbar cannot dissapear after the header turns smaller
        if (window.scrollY - 95 > 0) {
          body.classList.add("scroll");
        }
      }
    } else {
      body.classList.remove("scroll");
    }
  });

  /**
   * Header search Toggle
   */
  document.querySelectorAll(".header__search-toggle").forEach(el => {
    el.addEventListener("click", function () {
      toggleSearchContainer();
      handleNavigationClosure();
    });
  });

  /**
   * Search input event
   */
  document.querySelectorAll(".header__search-input").forEach(el => {
    el.addEventListener("click", handleSearchInput);
    el.addEventListener("input", handleSearchInput);
    el.addEventListener("keydown", function (e) {
      /**
       * Right arrow key press autocompletes the search input
       */
      if (e.key === "ArrowRight") {
        autoCompleteSearch();
      }
    });
  });

  function handleSearchInput() {
    const submitButton = this.closest(".header__search")?.querySelector(".header__search-button");
    if (!submitButton) return;
    if (this.value) {
      submitButton.classList.add("header__search-button--active");
    } else {
      submitButton.classList.remove("header__search-button--active");
    }
  }

  /**
   * Search hint field handling
   * Whenever the Solr suggestion field gets manipulated (shown, updated)
   * The hint field of the header search gets updated with the first suggestion loaded
   */
  const observerConfig = {childList: true, attributes: true, subtree: true};

  document.querySelectorAll(".autocomplete-suggestions").forEach(target => {
    const suggestionContainerObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {

        const hintContainer = Array.from(document.querySelectorAll(".header__search")).find(isVisible)?.querySelector(".header__hint");
        const hintContainerCE = document.querySelector(".search__hint");

        /**
         * If any Solr Suggestions occur, place the first suggestion in the hint field
         */
        if (mutation.attributeName === "style" || mutation.addedNodes.length || mutation.removedNodes.length) {
          const solrSuggestionContainer = mutation.target;

          const isSuggestionContainerVisible = (getComputedStyle(solrSuggestionContainer).display === "block");

          const visibleHeaderSearch = Array.from(document.querySelectorAll(".header__search")).find(isVisible);
          const inputValue = visibleHeaderSearch?.querySelector(".header__search-input")?.value ?? "";
          const inputValueCE = document.querySelector(".search__input")?.value ?? "";

          const hintPhrase = solrSuggestionContainer.querySelector(".autocomplete-suggestion")?.textContent ?? "";

          const hintPhraseToInsert = hintPhrase.substring(inputValue.length);
          const hintPhraseToInsertCE = hintPhrase.substring(inputValueCE.length);

          if (!!hintPhraseToInsert && isSuggestionContainerVisible && inputValue) {
            if (hintContainer) {
              hintContainer.innerHTML = "<div class=\"header__hint-hidden\">" + inputValue + "</div>" + hintPhraseToInsert;
            }
          } else {
            if (hintContainer) hintContainer.innerHTML = "";
          }

          const searchInput = document.querySelector(".search__input");
          if (!!hintPhraseToInsertCE && isSuggestionContainerVisible && inputValueCE && searchInput === document.activeElement) {
            solrSuggestionContainer.classList.add("is-from-search-ce");
            if (hintContainerCE) {
              hintContainerCE.innerHTML = "<div class=\"search__hint-hidden\">" + inputValueCE + "</div>" + hintPhraseToInsertCE;
            }
          } else {
            if (hintContainerCE) hintContainerCE.innerHTML = "";
          }
        }

        if (mutation.attributeName === "class" && mutation.target.classList.contains("autocomplete-selected")) {
          /**
           * If any Solr Suggestion gets selected (through arrow navigating), clear the hint field
           */
          if (!mutation.target.matches(":hover")) {
            if (hintContainer) hintContainer.innerHTML = "";
          }
        }
      });
    });
    suggestionContainerObserver.observe(target, observerConfig);
  });

  /**
   * Toggles the search container
   * @param searchClose determines whether an action should be fired which closes the
   * search container
   */
  const toggleSearchContainer = (searchClose = false) => {
    const visibleSearchToggle = Array.from(document.querySelectorAll(".header__search-toggle")).find(isVisible);
    const searchContainer = visibleSearchToggle?.closest(".header__search")?.querySelector(".header__search-container") ?? null;
    const inputSearchField = visibleSearchToggle?.closest(".header__search")?.querySelector(".header__search-input") ?? null;

    /**
     * Remove any search inputs from previous searches
     */
    if (inputSearchField) inputSearchField.value = "";

    /**
     * Search container toggle
     */
    if (searchClose) {
      searchContainer?.classList.remove("header__search-container--active");
      visibleSearchToggle?.classList.remove("header__search-toggle--active");
    } else {
      searchContainer?.classList.toggle("header__search-container--active");
      visibleSearchToggle?.classList.toggle("header__search-toggle--active");
    }

    /**
     * Set input field on focus / focusout
     */
    if (searchContainer?.classList.contains("header__search-container--active")) {
      inputSearchField?.focus();
    } else {
      inputSearchField?.blur();
    }
  };

  /**
   * Handles any dynamically added header functions to simulate mobile menu closure
   * Needed for resize (switch between desktop and mobile), and for mobile menu closer
   */
  const handleNavigationClosure = () => {
    document.documentElement.classList.remove("header-open");
    document.querySelectorAll(".header__menu").forEach(el => el.classList.remove("header__menu--open"));
    document.querySelector(".menu__button")?.classList.remove("menu__button--open");
    document.querySelectorAll(".mega-menu").forEach(el => el.classList.remove("mega-menu--open"));
    document.querySelectorAll(".column__subitems").forEach(el => el.classList.remove("column__subitems--open"));
    document.querySelectorAll(".item--has-megamenu-children").forEach(el => el.classList.remove("item--has-open-megamenu-children"));
    document.querySelectorAll(".mega-menu__item--has-subitems").forEach(el => el.classList.remove("mega-menu__item--has-open-subitems"));
  };

  /**
   * Inserts the type-ahead hint and clears the hint container
   */
  const autoCompleteSearch = () => {
    const visibleHeaderSearch = Array.from(document.querySelectorAll(".header__search")).find(isVisible);
    if (!visibleHeaderSearch) return;
    const headerHintContainer = visibleHeaderSearch.querySelector(".header__hint");
    const headerSearchInput = visibleHeaderSearch.querySelector(".header__search-input");

    const inputValue = headerSearchInput?.value ?? "";
    const hintPhrase = headerHintContainer?.textContent ?? "";

    if (!!hintPhrase && headerSearchInput && headerHintContainer) {
      headerSearchInput.value = inputValue + hintPhrase.substring(inputValue.length);
      headerHintContainer.innerHTML = "";
    }
  };
}
